import { useMemo } from "react";

import { useLabels } from "../../hooks/useLabels";
import { Icon } from "../icon/Icon";
import { Text } from "../text/Text";
import { TextEditorSaveState } from "./TextEditor";

export interface TextEditorSaveIndicatorProps {
  status: TextEditorSaveState;
}

const DEFAULT_TRANSLATIONS = {
  saving: "Saving draft",
  saved: "Saved draft",
};

export function TextEditorSaveIndicator({
  status,
}: TextEditorSaveIndicatorProps) {
  const { t } = useLabels();

  const renderedChildren = useMemo(() => {
    switch (status) {
      case TextEditorSaveState.pending:
        return (
          <>
            <Text size="xs" color="gray">
              {t("textEditor.saving", {}, DEFAULT_TRANSLATIONS.saving)}
            </Text>
            <Icon size="var(--size-2)" icon="circle-dashed" color="gray" />
          </>
        );
      case TextEditorSaveState.successful:
        return (
          <>
            <Text size="xs" color="gray">
              {t("textEditor.saved", {}, DEFAULT_TRANSLATIONS.saved)}
            </Text>
            <Icon size="var(--size-2)" icon="circle-check" color="gray" />
          </>
        );
      // FIXME this hits when the fetch is cancelled
      // case TextEditorSaveState.failed:
      //   return (
      //     <Text size="xs" color="error">
      //       Failed to save!
      //     </Text>
      //   );
      default:
        return;
    }
  }, [status, t]);

  return <div className="TextEditorSaveIndicator">{renderedChildren}</div>;
}
